import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import ReactApexChart from "react-apexcharts";
export default function Dashboard() {
    const [lists, setLists] = useState([]);
    const [lenders, setLenders] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [counts, setCounts] = useState({});
    const ApplicantsGraph = () => {
        var options = {
            chart: {
                height: 350,
                type: 'bar',
                events: {
                    click: function (chart, w, e) {
                        console.log(1)
                    }
                },
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: '45%',
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false
            },
            xaxis: {
                categories: [
                    'Applications', 'Data Missing', 'Documents Missing', 'Waitng for Approvals', 'Approved By lenders', 'Approved Clients'
                ],
                labels: {
                    style: {
                        fontSize: '12px'
                    }
                }
            }
        };
        var series = [{
            data: [20, 30, 10, 5, 60, 40]
        }]
        return (
            <ReactApexChart
                className="apex-charts"
                series={series}
                options={options}
                type="bar"
                height={267.7}
            />
        )
    }
    const UsageGraph = () => {
        var options = {
            chart: {
                height: 350,
                type: 'bar',
                events: {
                    click: function (chart, w, e) {
                        console.log(1)
                    }
                },
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: '45%',
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false
            },
            xaxis: {
                categories: [
                    'Applications', 'SMS', 'Phone Calls', 'Money Thumb', 'Email'
                ],
                labels: {
                    style: {
                        fontSize: '12px'
                    }
                }
            }
        };
        var series = [{
            data: [20, 30, 10, 50, 25]
        }]
        return (
            <ReactApexChart
                className="apex-charts"
                series={series}
                options={options}
                type="bar"
                height={267.7}
            />
        )
    }
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetCount = () => {
        axios
            .get(config.APIACTIVATEURL + config.ADMINDASHBOARD, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setCounts(response.data)
                }
            });
    };
    const GetLastPageData = () => {
        GetData(totalPages)
    }
    const GetFirstPageData = () => {
        GetData("1")
    }
    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number)
            GetData(number)
    }
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });
    const GetData = (number) => {
        axios
            .get(config.APIACTIVATEURL + config.GETLENDINGAPPLICATIONS + "?pageNumber=" + number + "&pageSize=" + pageSize + "", { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data.data);
                    setPageNumber(response.data.data.pageNumber);
                    setPageSize(response.data.data.pageSize);
                    setTotalPages(response.data.data.totalPages);
                    setData(response.data.data);
                    setTotalRecords(response.data.data.totalRecords);
                }
            });
    };
    const GetLenderCommission = (number) => {
        axios
            .get(config.APIACTIVATEURL + config.GETLENDERSCOMMISSIONS + "?LenderId=00000000-0000-0000-0000-000000000000&pageNumber=" + number + "&pageSize=" + pageSize + "", { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLenders(response.data.data.data);
                    setPageNumber(response.data.data.pageNumber);
                    setPageSize(response.data.data.pageSize);
                    setTotalPages(response.data.data.totalPages);
                    setData(response.data.data);
                    setTotalRecords(response.data.data.totalRecords);
                }
            });
    };
    useEffect(() => {
        GetData(pageNumber);
        GetLenderCommission(pageNumber);
        GetCount();
    }, [])
    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="vertical-overlay" />
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card text-white bg-primary-gt overflow-hidden">
                                <div className="card-body position-relative z-1">
                                    <span className="badge badge-custom-dark d-inline-flex align-items-center gap-2 fs-3">
                                        <iconify-icon icon="solar:check-circle-outline" className="fs-5" />
                                        <span className="fw-normal">This month <span className="fw-semibold">+15%
                                            New Users</span>
                                        </span>
                                    </span>
                                    <h4 className="text-white fw-normal mt-5 pt-7 mb-1">Hey, <span className="fw-semibold">{localStorage.getItem("name")}</span>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="card bg-danger-subtle overflow-hidden shadow-none">
                                        <div className="card-body px-4" style={{minHeight:"210px"}}>
                                            <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-secondary flex-shrink-0 mb-3 mx-auto">
                                                <iconify-icon icon="mdi:account-group" className="fs-7 text-white" />
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-8">
                                                <div>
                                                    <span className="text-dark-light fw-semibold fs-12">Active Clients</span>
                                                    <div className="hstack gap-2">
                                                        <h5 className="card-title fw-semibold mb-0 fs-7">{counts.activeClients}</h5>
                                                        <Link to="/report/clients" style={{ cursor: 'pointer' }}><i className="fa fa-eye text-muted me-2"></i>View</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card bg-secondary-subtle overflow-hidden shadow-none">
                                        <div className="card-body px-4">
                                            <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-secondary flex-shrink-0 mb-3 mx-auto">
                                                <iconify-icon icon="material-symbols:subscriptions" className="fs-7 text-white" />
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-8">
                                                <span className="text-dark-light fw-semibold fs-12">Active Subscriptions</span>
                                            </div>
                                            <div className="hstack gap-2">
                                                <h5 className="card-title fw-semibold mb-0 fs-7">{counts.activeSubscriptions}</h5>
                                                <Link to="/report/clients" style={{ cursor: 'pointer' }}><i className="fa fa-eye text-muted me-2"></i>View</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card bg-primary-subtle overflow-hidden shadow-none">
                                        <div className="card-body px-4">
                                            <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-primary flex-shrink-0 mb-3 mx-auto">
                                                <iconify-icon icon="material-symbols:monetization-on" className="fs-7 text-white" />
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mb-8">
                                                <span className="text-dark-light fw-semibold fs-12">Money Thumb Credits Available</span>                                                
                                            </div>
                                            <div className="hstack gap-2">
                                                    <h5 className="card-title fw-semibold mb-0 fs-7">{counts.moneyThumbAvailableCredits}</h5>
                                                </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div className="row flex-nowrap">
                        <div className="col">
                            <div className="card primary-gradient">
                                <div className="card-body text-center px-9 pb-4">
                                    <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-primary flex-shrink-0 mb-3 mx-auto">
                                        <iconify-icon icon="material-symbols:thumb-up" className="fs-7 text-white" />
                                    </div>
                                    <h6 className="fw-normal fs-3 mb-1">Submitted</h6>
                                    <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                        {counts.submitted}</h4>
                                    <Link to={"/lendingapplications/submitted"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View Details</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card warning-gradient">
                                <div className="card-body text-center px-9 pb-4">
                                    <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-warning flex-shrink-0 mb-3 mx-auto">
                                        <iconify-icon icon="solar:recive-twice-square-linear" className="fs-7 text-white" />
                                    </div>
                                    <h6 className="fw-normal fs-3 mb-1">Pending</h6>
                                    <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                        {counts.pending}</h4>
                                    <Link to={"/lendingapplications/pending"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View Details</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card secondary-gradient">
                                <div className="card-body text-center px-9 pb-4">
                                    <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-success flex-shrink-0 mb-3 mx-auto">
                                        <iconify-icon icon="material-symbols:thumb-up" className="fs-7 text-white" />
                                    </div>
                                    <h6 className="fw-normal fs-3 mb-1">Approved</h6>
                                    <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                        {counts.approved}</h4>
                                    <Link to={"/lendingapplications/approved"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View Details</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card danger-gradient">
                                <div className="card-body text-center px-9 pb-4">
                                    <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-danger flex-shrink-0 mb-3 mx-auto">
                                        <iconify-icon icon="ic:baseline-sync-problem" className="fs-7 text-white" />
                                    </div>
                                    <h6 className="fw-normal fs-3 mb-1">Awaiting Funding</h6>
                                    <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                        {counts.waitingFunding}</h4>
                                    <Link to={"/lendingapplications/waitingfunding"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View Details</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card success-gradient">
                                <div className="card-body text-center px-9 pb-4">
                                    <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-danger flex-shrink-0 mb-3 mx-auto">
                                        <iconify-icon icon="material-symbols:thumb-down-sharp" className="fs-7 text-white" />
                                    </div>
                                    <h6 className="fw-normal fs-3 mb-1">Declined</h6>
                                    <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                        {counts.declined}</h4>
                                    <Link to={"/lendingapplications/declined"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View Details</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card success-gradient">
                                <div className="card-body text-center px-9 pb-4">
                                    <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-success flex-shrink-0 mb-3 mx-auto">
                                        <iconify-icon icon="material-symbols:supervisor-account" className="fs-7 text-white" />
                                    </div>
                                    <h6 className="fw-normal fs-3 mb-1">Users</h6>
                                    <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                        {counts.activeUsers}</h4>
                                    <Link to={"/lendingapplications/submitted"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View Details</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card success-gradient">
                                <div className="card-body text-center px-9 pb-4">
                                    <div className="d-flex align-items-center justify-content-center round-48 rounded text-bg-success flex-shrink-0 mb-3 mx-auto">
                                        <iconify-icon icon="material-symbols:description" class="fs-7 text-white" />

                                    </div>
                                    <h6 className="fw-normal fs-3 mb-1">Applications</h6>
                                    <h4 className="mb-3 d-flex align-items-center justify-content-center gap-1">
                                        {counts.totalApplications}</h4>
                                    <Link to={"/lendingapplications/submitted"} className="btn btn-primary fs-2 fw-semibold text-nowrap">View Details</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-secondary bg-gradient">
                                <div className="card-body">
                                    <Link to={"/report/clients"} className="text-uppercase fw-medium text-truncate mb-0 p-1 text-white">Active Clients : {counts.activeClient}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-success bg-gradient bg-opacity-50">
                                <div className="card-body">
                                    <p className="text-uppercase fw-medium text-truncate mb-0 p-1">Money Thumb Credits Used : {counts.moneyThumbUsedCredits}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-warning bg-gradient bg-opacity-50">
                                <div className="card-body">
                                    <Link to={"/lendingApplications/pending"} className="text-uppercase fw-medium text-truncate mb-0 p-1 text-black">Pending Applications : {counts.pending}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-success">
                                <div className="card-body">
                                    <Link to={"/applications/approved"} className="text-uppercase fw-medium text-truncate mb-0 p-1 text-white">Approved : {counts.approved}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-warning bg-gradient bg-opacity-50">
                                <div className="card-body">
                                    <p className="text-uppercase fw-medium text-truncate mb-0 p-1">SMS Sent : {counts.smsSent}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-warning">
                                <div className="card-body">
                                    <p className="text-uppercase fw-medium text-truncate mb-0 p-1 text-wrap">Money Thumbs Credits Remaining : {counts.moneyThumbAvailableCredits}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-secondary bg-gradient bg-opacity-50">
                                <div className="card-body">
                                    <Link to={"/lendingApplications/submitted"} className="text-uppercase fw-medium text-truncate mb-0 p-1 text-black">Applications Submitted : {counts.submitted}</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <div className="card bg-danger">
                                <div className="card-body">
                                    <Link to={"/applications/rejected"} className="text-uppercase fw-medium text-truncate mb-0 p-1 text-white">Declined : {counts.declined}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6">
                            <div className="card card-height-100">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Lender Rankings</h4>
                                    <div className="flex-shrink-0">
                                        <Link to={"/lenders/rankings"} className="btn btn-soft-primary btn-sm">View All Lenders <i className="ri-arrow-right-line align-bottom" /></Link>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Lender</th>
                                                    <th>Commission</th>
                                                    <th>Approved Volume</th>
                                                    <th>Approved Units</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {lenders.length > 0 && lenders.map((v, index) =>
                                                    <tr key={v.lenderId}>
                                                        <td>{index + 1}</td>
                                                        <td>{v.lenderName}</td>
                                                        <td>USD {v.totalCommission}</td>
                                                        <td>USD {v.totalLoanAmount}</td>
                                                        <td>{v.approvedLoansCount}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={"page-item" + data.previousPage === null ? 'disabled' : ''} onClick={() => GetFirstPageData()}>
                                                <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + data.nextPage === null ? 'disabled' : ''} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="card card-height-100">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Recent Applications</h4>
                                    <div className="flex-shrink-0">
                                        <Link to={"/lendingApplications"} className="btn btn-soft-primary btn-sm">View All Applications <i className="ri-arrow-right-line align-bottom" /></Link>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Company</th>
                                                    <th>Contact Name</th>
                                                    <th>Business Email</th>
                                                    <th>Mobile</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {lists.length > 0 && lists.map((v, index) =>
                                                    <tr key={v.lenderId}>
                                                        <td>{index + 1}</td>
                                                        <td>{v.businessLegalName}</td>
                                                        <td>{v.oFirstName}</td>
                                                        <td>{v.businessEmail}</td>
                                                        <td>
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                                                    <Link className="edit-item-btn" to={"/lendingapplication/" + v.lendingApplicationId}><i className="ri-pencil-fill align-bottom text-muted" /></Link>
                                                                </li>
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                                    <Link className="edit-item-btn" to={"/viewlendingapplication/" + v.lendingApplicationId}><i className="ri-eye-fill align-bottom text-muted" /></Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={"page-item" + data.previousPage === null ? 'disabled' : ''} onClick={() => GetFirstPageData()}>
                                                <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + data.nextPage === null ? 'disabled' : ''} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card">
                                <div className="card-header border-0 align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Usage Status</h4>
                                </div>
                                <div className="card-body">
                                    <UsageGraph type="bar" height={350} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card">
                                <div className="card-header border-0 align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Applications Status</h4>
                                </div>
                                <div className="card-body">
                                    <ApplicantsGraph type="bar" height={350} />
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
}